import { hasCookiebotConsent } from '@/hooks/use-cookiebot-consent';

type CapiEventBase = {
  id: string;
  sourceUrl?: string;
};

export const hasCapiMarketingConsent = (): boolean => hasCookiebotConsent('marketing');

/** Shared event id for GTM `event_id` and CAPI `id`. */
export const createTrackingEventId = (): string => crypto.randomUUID();

export const createTrackingEventBase = (eventId: string): CapiEventBase | null => {
  if (typeof window === 'undefined' || !hasCapiMarketingConsent()) {
    return null;
  }

  return {
    id: eventId,
    sourceUrl: window.location.href,
  };
};

export const isDedicatedCapiPageViewPath = (pathname: string): boolean => {
  if (pathname.startsWith('/studio')) {
    return true;
  }

  return /^\/[^/]+\/product\/[^/]+/.test(pathname) || /^\/[^/]+\/products\/[^/]+/.test(pathname);
};
